import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@env/environment";
import { Client } from "@jack-sparrow-libraries/emotion-models";
import { jwtDecode } from "jwt-decode";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	loginUrl: string = `${environment.apiEmotion()}/login/loginManage `;

	constructor() {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const userToken = localStorage.getItem("authToken");
		const strImpersonate = localStorage.getItem("impersonate");
		let tokenImpersonate: string | null = null;

		if (
			req.url.startsWith(environment.adresseApiInsee) ||
			req.url.startsWith(environment.adresseApiGouv.url) ||
			req.url.startsWith(environment.adresseApiMedicaments)
		) {
			return next.handle(req);
		}

		if (strImpersonate) {
			try {
				const impersonate: { token: string; client: Client } | null = JSON.parse(strImpersonate);
				tokenImpersonate = impersonate.token || null;
			} catch (err) {
				tokenImpersonate = null;
			}
		}

		// Exception pour l'appel à l'api gouvernemantale de récupération adresses
		if (req.url.includes("api-adresse.data.gouv.fr")) {
			return next.handle(req);
		}

		const reqWithVersion = req.clone({
			setHeaders: {
				versioncba: "W",
			},
		});

		if ((tokenImpersonate !== null || userToken !== null) && req.url !== this.loginUrl) {
			let headers: HttpHeaders = this.addAuthorizationIfNotExists(reqWithVersion, tokenImpersonate ?? userToken);

			try {
				const decoded = jwtDecode<{ sub: string }>(userToken);
				if (decoded?.sub) {
					headers = headers.set("X-Sso-Id", decoded.sub);
				}
			} catch (_) {}

			if (tokenImpersonate) {
				try {
					const decodedImpersonate = jwtDecode<{ client_delegue_sso_id?: string }>(tokenImpersonate);
					if (decodedImpersonate?.client_delegue_sso_id) {
						headers = headers.set("X-Sso-Id-Delegue", decodedImpersonate.client_delegue_sso_id);
					}
				} catch (_) {}
			}

			return next.handle(
				reqWithVersion.clone({
					headers,
				}),
			);
		}
		return next.handle(reqWithVersion);
	}

	private addAuthorizationIfNotExists(req: HttpRequest<any>, token: string): HttpHeaders {
		const headers: any = { Authorization: `Bearer ${token}` };
		req.headers.keys().forEach((key) => {
			headers[key] = req.headers.get(key);
		});
		return new HttpHeaders(headers);
	}
}
